{
	"locales": {
		"de-DE": "de_DE",
		"en-AU": "en_AU",
		"en-CA": "en_US",
		"en-GB": "en_GB",
		"en-IN": "en_GB",
		"en-US": "en_US",
		"es-ES": "es_ES",
		"es-419": "es_ES",
		"es-AR": "es_ES",
		"fr-FR": "fr_FR",
		"hi-IN": "en_GB",
		"id-ID": "id_ID",
		"it-IT": "it_IT",
		"ja-JP": "ja_JP",
		"ko-KR": "ko_KR",
		"pt-BR": "pt_BR",
		"ru-RU": "ru_RU",
		"th-TH": "th_TH",
		"tr-TR": "en_US"
	}
}
